module.exports = __webpack_public_path__ + "media/images/shapes/angles/angle-left-e82990d38ee756270f215412d8ca0b928023e82ed414ca8b1772845722bd60c8.svg";